export default class InfoNCA_lineage2{
    constructor(_wrapper: HTMLElement) {
        this.templ(_wrapper);
    }

    templ(_parent: HTMLElement){
        _parent.classList.add('footer-info-naeu');
        _parent.innerHTML= `
        <div class="footer-rating">
            <img src="https://assets.playnccdn.com/resource/lineage2/footer-rating-esrb.png">
        </div>
        `;
    }
}
